import { JOB_OPPORTUNITY_STATUSES } from "lookup";
import { cn } from "utils";
import { formatJobStatus } from "utils/helpers/jobOppDetails";

function StatusField({ status, hasPrimaryMatcher }) {
  if (!status) return null;

  const jobIsActionable =
    status === JOB_OPPORTUNITY_STATUSES.ACTIVE && hasPrimaryMatcher;

  return (
    <h3
      className={cn("rounded-md h-fit px-3 py-1 font-medium", {
        "text-green-500 bg-green-50": jobIsActionable,
        "text-slate-500 bg-slate-50": !jobIsActionable,
      })}
    >
      {formatJobStatus(status)}
    </h3>
  );
}

export default StatusField;
